import { ColumnViewModel } from '../../shared/column-types';

export const DISEASES_GDA_SUMMARY: ColumnViewModel = {
  columns: [
    'evidenceTimeline',
    'diseaseName',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'geneSymbol',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'geneDescription',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'geneEnsemblIDs',
    'geneProteinStrIDs',
    'geneProteinClassNames',
    'geneNcbiType',
    'pathwayName',
    'pathwayID',
    'numCTs',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'prevalence',
    'disease_inheritance',
    'chemPrefName',
    'chemID',
  ],
  defaultVisible: [
    'evidenceTimeline',
    'diseaseName',
    'geneSymbol',
    'geneDescription',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'numDBSNPsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'numCTs',
  ],
};